function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useEffect, useRef, useState } from 'react';
import { cloneDeep, has, isArray } from 'lodash';
import { getAllQuoteQuestionInfoMap } from '../../localeConstants';
export var useQuoteDynamicDeclaration = function useQuoteDynamicDeclaration() {
  var _useState = useState([]),
      specList = _useState[0],
      setSpecList = _useState[1];

  var _useState2 = useState(false),
      haveOther = _useState2[0],
      setHaveOther = _useState2[1];

  var _useState3 = useState(''),
      comment = _useState3[0],
      setComment = _useState3[1];

  var _useState4 = useState(null),
      questionInfo = _useState4[0],
      setQuestionInfo = _useState4[1];

  var declarationCommonViewRef = useRef(null);

  var _useState5 = useState(),
      selectQuestion = _useState5[0],
      setSelectQuestion = _useState5[1];
  /**
   * effects
   */


  useEffect(function () {
    setHaveOther(findSelectOptionHaveOther(specList));
  }, [specList]);
  /**
   *
   * @param item methdos
   */

  var findSelectOptionHaveOther = function findSelectOptionHaveOther(list) {
    var _iterator = _createForOfIteratorHelper(list),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;

        if (isArray(item.list)) {
          if (findSelectOptionHaveOther(item.list)) {
            return true;
          }
        } else {
          if (!!(item !== null && item !== void 0 && item.showCheckbox) && (item === null || item === void 0 ? void 0 : item.uniqueId) === 'Other' && (item === null || item === void 0 ? void 0 : item.checked) === true) {
            return true;
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return false;
  };

  var deepEvaluateSelectedValue = function deepEvaluateSelectedValue(list, checkedList) {
    list.forEach(function (item) {
      if (isArray(item.list)) {
        deepEvaluateSelectedValue(item.list, checkedList);
      } else {
        if (has(item, 'checked')) {
          item.checked = checkedList.includes(item.uniqueId);
        }
      }
    });
  };

  var evaludateDynamicQuestionInfo = function evaludateDynamicQuestionInfo(data) {
    if (data !== null && data !== void 0 && data.displayInfoQuestionId) {
      var _declarationCommonVie;

      var _questionInfo = cloneDeep(getAllQuoteQuestionInfoMap()[data.displayInfoQuestionId]);

      deepEvaluateSelectedValue(_questionInfo.spec, (data === null || data === void 0 ? void 0 : data.extraDeclarationSelectOptionList) || []);
      (_declarationCommonVie = declarationCommonViewRef.current) === null || _declarationCommonVie === void 0 ? void 0 : _declarationCommonVie.allowSelectDeclarationOptions((data === null || data === void 0 ? void 0 : data.selectValue) === false);
      setSpecList(_questionInfo.spec);
      setQuestionInfo(_questionInfo);
    }
  };

  var questionSelectAction = function questionSelectAction(item) {
    var _declarationCommonVie2;

    setSelectQuestion(item);
    (_declarationCommonVie2 = declarationCommonViewRef.current) === null || _declarationCommonVie2 === void 0 ? void 0 : _declarationCommonVie2.allowSelectDeclarationOptions((item === null || item === void 0 ? void 0 : item.truelyValue) === false);
  };

  var specListChangeAction = function specListChangeAction(list) {
    setSpecList(list);
  };

  var commentChangeAction = function commentChangeAction(value) {
    setComment(value);
  };

  return {
    useQuoteDynamicDeclaration: useQuoteDynamicDeclaration,
    questionSelectAction: questionSelectAction,
    specListChangeAction: specListChangeAction,
    commentChangeAction: commentChangeAction,
    specList: specList,
    setSpecList: setSpecList,
    haveOther: haveOther,
    setHaveOther: setHaveOther,
    comment: comment,
    setComment: setComment,
    evaludateDynamicQuestionInfo: evaludateDynamicQuestionInfo,
    questionInfo: questionInfo,
    declarationCommonViewRef: declarationCommonViewRef,
    selectQuestion: selectQuestion,
    setSelectQuestion: setSelectQuestion
  };
};